

<app-header>

    <div class="agilweb-body">

        <mat-tab-group selectedIndex="0" mat-align-tabs="center" [dynamicHeight]='true'>
            <mat-tab label="Perfil">

                <app-profile
                *ngIf="!editMode"
                [user]="user"
                (showEditComponentEmitter)="showEditComponent($event)"
                ></app-profile>

                <app-edit-user
                *ngIf="editMode"
                [selfEdit]="true"
                [user]="user"
                (hideEditComponentEmitter)="hideEditComponent($event)">
                </app-edit-user>
            </mat-tab>

            <mat-tab label="Margem" *ngIf="hasPermission('ROLE_MARGIN_EDIT')">
                <app-account-margin></app-account-margin>
            </mat-tab>

        </mat-tab-group>

    </div>

</app-header>

